/**
 * True for the bare third-party iframe embed routes (/embed/[name]/), which
 * must not load site chrome or telemetry: TawkChat, CookieConsent/GTM,
 * AttributionTracker and PostHog (instrumentation-client.ts) all check this.
 */
export function isEmbedPath(pathname?: string | null): boolean {
  return !!pathname && (pathname === '/embed' || pathname.startsWith('/embed/'));
}
